import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useCallback, useEffect, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
export function useCuttedTextSign(ref) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isCuttedText = _useState2[0],
      setIsCuttedText = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  var handleResizeObserver = useCallback(function () {
    if (ref.current) {
      var _ref$current = ref.current,
          offsetHeight = _ref$current.offsetHeight,
          scrollHeight = _ref$current.scrollHeight;
      setIsCuttedText(scrollHeight > offsetHeight);
      setHeight(offsetHeight);
    }
  }, [ref]);
  useEffect(function () {
    if (ref.current) {
      var observer = new ResizeObserver(handleResizeObserver);
      observer.observe(ref.current);
      return function () {
        observer.disconnect();
      };
    }

    return function () {
      return null;
    };
  }, [handleResizeObserver, ref]);
  return {
    isCuttedText: isCuttedText,
    height: height
  };
}